export default __webpack_public_path__ + "static/media/index.b1012bea.less";